import api from './api';

class ResourceAllocationService {
  // Get all resource allocations with pagination and filtering
  static async getResourceAllocations(params = {}) {
    try {
      const response = await api.get('/resource-allocation', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching resource allocations:', error);
      throw this.handleError(error);
    }
  }

  // Get resource allocation by ID
  static async getResourceAllocation(id) {
    try {
      const response = await api.get(`/resource-allocation/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching resource allocation:', error);
      throw this.handleError(error);
    }
  }

  // Create new resource allocation
  static async createResourceAllocation(allocationData) {
    try {
      const response = await api.post('/resource-allocation', allocationData);
      return response.data;
    } catch (error) {
      console.error('Error creating resource allocation:', error);
      throw this.handleError(error);
    }
  }

  // Update resource allocation
  static async updateResourceAllocation(id, allocationData) {
    try {
      const response = await api.put(`/resource-allocation/${id}`, allocationData);
      return response.data;
    } catch (error) {
      console.error('Error updating resource allocation:', error);
      throw this.handleError(error);
    }
  }

  // Delete resource allocation
  static async deleteResourceAllocation(id) {
    try {
      const response = await api.delete(`/resource-allocation/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting resource allocation:', error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      const errorData = error.response.data;
      const errorMessage = errorData?.message || 
                          errorData?.error || 
                          (errorData?.errors && errorData.errors.length > 0 
                            ? errorData.errors.map(e => e.msg || e.message).join(', ') 
                            : 'An error occurred');
      
      return {
        message: errorMessage,
        status: error.response.status,
        data: errorData
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default ResourceAllocationService;